enum SCP_FRAMES_REQUEST_PRIORITY_TYPES {
    LOW_PRIORITY = 0,
    HIGH_PRIORITY = 1,
    TOP_PRIORITY = 2,
}

export default SCP_FRAMES_REQUEST_PRIORITY_TYPES;
